<template>
  <div class="ckeditor">
    <textarea
      :name="name"
      :id="id"
      :value="value"
      :types="types"
      :config="config">
    </textarea>
  </div>
</template>

<script>
import bus from '@/utils/bus';

const inc = new Date().getTime();

export default {
  name: 'vue-ckeditor',
  props: {
    name: {
      type: String,
      default: () => `editor-${inc + 1}`,
    },
    value: {
      type: String,
    },
    id: {
      type: String,
      default: () => `editor-${inc}`,
    },
    types: {
      type: String,
      default: () => 'classic',
    },
    config: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      destroyed: false,
    };
  },

  computed: {
    instance() {
      return CKEDITOR.instances[this.id];
    },
  },

  watch: {
    value(val) {
      try {
        if (this.instance) {
          this.update(val);
        }
      } catch (e) {
        console.error(e);
      }
    },
  },

  mounted() {
    this.create();

    bus.$on('destroy-editor', () => {
      this.destroy();
    });
  },

  beforeDestroy() {
    this.destroy();
  },

  destroyed() {
    bus.$off('destroy-editor');
  },

  methods: {
    create() {
      if (typeof CKEDITOR === 'undefined') {
        console.log('CKEDITOR is missing (http://ckeditor.com/)');
      } else {
        if (this.types === 'inline') {
            CKEDITOR.inline(this.id, this.config);
        } else {
            CKEDITOR.replace(this.id, this.config);
        }

        this.instance.setData(this.value);
        this.instance.on('instanceReady', () => {
          this.instance.setData(this.value);
        });
        this.instance.on('change', this.onChange);
        this.instance.on('blur', this.onBlur);
        this.instance.on('focus', this.onFocus);
      }
    },

    update(val) {
      const html = this.instance.getData();
      if (html !== val) {
        this.instance.setData(val, { internal: false });
      }
    },

    destroy() {
      if (!this.destroyed) {
        try {
          this.instance.focusManager.blur(true);
          this.instance.removeAllListeners();
          this.instance.destroy();
          this.destroyed = true;
        } catch (e) {
          console.error(e);
        }
      }
    },

    onChange() {
      const html = this.instance.getData();
      if (html !== this.value) {
        this.$emit('input', html);
      }
    },

    onBlur() {
      this.$emit('blur', this.instance);
    },

    onFocus() {
      this.$emit('focus', this.instance);
    },
  },
};
</script>

<style>
  .ckeditor::after {
    content: "";
    display: table;
    clear: both;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/common/Ckeditor.vue